// ref: https://gitlab.com/web-apps-dietela/backend/-/merge_requests/262

export const reqGetDetailContent = async(axios, id) => {
  return axios.get(`/v1/clients/content-and-challenge/${id}`)
}

export const reqGetListIdContentForTracking = async(axios) => {
  return axios.get('/v1/clients/content-snacking-guidance')
}